export function createSearchMatcher(search: string) {
  const searchParts = search
    .toLowerCase()
    .split(/\s+/g)
    .map((i) => i.trim())
    .filter(Boolean);
  const parts = [...searchParts]
    // Prioritise longest word first
    .sort((a, b) => b.length - a.length);
  const regexes = parts.map((i) => new RegExp(`\\b${RegExp.escape(i)}`, "i"));
  return {
    serverSearchPart: parts[0] ?? "",
    /**
     * Scores a description based on how well it matches a search term.
     * A higher score is better.
     * 0 - No match
     * 1 - Match, but not at the start
     * 2 - Match, at the start
     */
    matchScore: (description: string) => {
      if (searchParts.length === 0) return 1;
      if (!regexes.every((i) => i.test(description))) return 0;
      if (description.toLowerCase().startsWith(searchParts[0])) return 2;
      return 1;
    },
  };
}
